import Cookies from '@ictlife/core/config/cookies';
import axiosConfig from '../../config/axiosConfig';
import { LOADING, SUCCESS, ERROR } from '../dispatchTypes';

export const forgotPassword = async bodyData => {
  return await axiosConfig.post('/forgot_password', bodyData);
};

export const setPasswordRequest = (dispatch, bodyData) => {
  const resetPasswordData = JSON.parse(localStorage.resetPasswordData);
  dispatch({
    type: LOADING,
  });

  axiosConfig
    .post('/set_password', bodyData, {
      params: {
        token: resetPasswordData.reset_password_token,
      },
    })
    .then(() => {
      dispatch({
        type: SUCCESS,
      });
    })
    .catch(error => {
      dispatch({
        type: ERROR,
        errorMessage: error.response.data.error_message,
      });
    })
    .catch(() => {
      dispatch({
        type: ERROR,
        errorMessage:
          'Something went wrong. Kindly refresh your browser and try again',
      });
    });
};

export const changePassword = (dispatchChangePassword, bodyData) => {
  const currentUserId = JSON.parse(Cookies.get('ictl_user')).id;

  dispatchChangePassword({
    type: LOADING,
  });

  axiosConfig
    .post(`/users/${currentUserId}/change_password`, bodyData)
    .then(() => {
      dispatchChangePassword({
        type: SUCCESS,
      });
    })
    .catch(error => {
      dispatchChangePassword({
        type: ERROR,
        errorMessage: error.response.data.error_message,
      });
    })
    .catch(() => {
      dispatchChangePassword({
        type: ERROR,
        errorMessage:
          'Something went wrong. Kindly refresh your browser and try again',
      });
    });
};
